<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['贸易对接']" />
    <div class="rhBrand-content common-padding">
<!--      <el-card class="box-card">-->
<!--        <el-row :gutter="20">-->
<!--          <el-col :span="4">-->
<!--            <span class="search-text">发件公司：</span>-->
<!--            <el-input v-model.trim="companyName" placeholder="请输入发件公司" class="search-item"></el-input>-->
<!--          </el-col>-->
<!--          <el-col :span="5">-->
<!--            <el-button @click="getPageList" class="btn-search" round icon="el-icon-search">查询</el-button>-->
<!--            <el-button @click="reset" type="warning" round icon="el-icon-refresh">重置</el-button>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-card>-->
      <el-card class="box-card flex-1 table-card">
        <!--        <el-button-->
        <!--            :disabled="selectData.length === 0"-->
        <!--            type="danger"-->
        <!--            icon="el-icon-delete"-->
        <!--            size="medium"-->
        <!--            @click="deleteMore"-->
        <!--        >批量删除</el-button-->
        <!--        >-->
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" style="width: 100%" @selection-change="selectRow" border class="flex-1" stripe height="100%">
            <el-table-column type="index" width="60px" align="center"></el-table-column>
            <el-table-column label="企业类型" prop="one" align="center">
              <template slot-scope="scope">
                {{ getType(scope.row.one, scope.row.two) }}
              </template>
            </el-table-column>
            <el-table-column width="200px" label="用户标签" prop="userLevel" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                {{getUserLevel(scope.row.userLevel)}}
              </template>
            </el-table-column>
            <el-table-column label="来源" prop="sourceName" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="发信时间" prop="createTime" align="center" sortable
              show-overflow-tooltip></el-table-column>
            <el-table-column label="标签" prop="needName" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" prop="isRead" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.isRead === '2' ? '已读' : '未读' }}
              </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="checkDetail(scope.row.id)">查看
                </el-button>
                <!--                <el-button-->
                <!--                    size="mini"-->
                <!--                    type="danger"-->
                <!--                    @click="handleDelete(scope.row.id)"-->
                <!--                >删除</el-button-->
                <!--                >-->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  name: 'tradeIndex',
  data () {
    return {
      ids: '',
      companyName: '',
      tableData: [],
      selectData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'TradeDetail') {
      sessionStorage.setItem('currentPage', this.currentPage)
      sessionStorage.setItem('pageSize', this.pageSize)
      sessionStorage.setItem('companyName', this.companyName)
    } else {
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('pageSize')
      sessionStorage.removeItem('companyName')
    }
    next()
  },
  created () {
    if (sessionStorage.getItem('currentPage')) { this.currentPage = Number(sessionStorage.getItem('currentPage')) }
    if (sessionStorage.getItem('pageSize')) { this.pageSize = Number(sessionStorage.getItem('pageSize')) }
    if (sessionStorage.getItem('companyName')) { this.companyName = sessionStorage.getItem('companyName') }
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        companyName: this.companyName
      }
      let { data: res } = await this.$http.post(
        '/tradeDocking/pageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.companyName = ''
      this.currentPage = 1
      this.pageSize = 10
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    deleteMore () {
      let ids = this.selectData.map((item) => {
        return item.id
      }).join(',')
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$http.post('/tradeDocking/batchDelete', { ids }).then(res => {
            if (res.data.code === '200') {
              this.$message.success('删除成功!')
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/tradeDocking/batchDelete', { ids: id }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    checkDetail (id) {
      // VerifyDetail
      this.$router.push({
        name: 'TradeDetail',
        params: {
          id
        }
      })
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    verifyMore () {
      this.checkList = []
      this.dialogShow = true
      let list = this.selectData.map(item => item.id)
      this.ids = list.join(',')
    },
    verify (id, status, reason) {
      this.checkList = []
      this.dialogShow = true
      this.ids = id
      this.verifyForm.status = status
      this.verifyForm.reason = reason
    },
    selectRemark (val) {
      this.verifyForm.reason = val.join(',')
    },
    confirm () {
      this.$refs.verifyForm.validate((val) => {
        if (val) {
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          let params = JSON.parse(JSON.stringify(this.verifyForm))
          params.ids = this.ids
          this.$http
            .post('/supplyDemand/audit', params)
            .then((res) => {
              if (res.data.code === '200') {
                this.dialogShow = false
                this.getPageList()
                this.$message.success(res.data.msg)
                this.checkList = []
              }
            })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    getType (one, two) {
      if (one && two) {
        return one + ' | ' + two
      } else if (one && !two) {
        return one
      } else if (!one && two) {
        return two
      } else {
        return ''
      }
    },
    getUserLevel (level) {
      if (level === '5') return '专业买家'
      if (level === '7') return 'CBE展商'
      return ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tradeDocking/index.vue